const rateHasAmenity = (rate, amenityType) => Boolean(rate?.amenities?.some(amenity => (amenity.slug ?? amenity.type) === amenityType));
export const findRateWithAmenity = (rates, amenityType) => rates?.find(rate => rateHasAmenity(rate, amenityType));
export const findRateForActiveAmenities = (rates, selectedRate, activeAmenities) => {
    const missingAmenity = activeAmenities?.find(amenityType => !rateHasAmenity(selectedRate, amenityType));
    if (!missingAmenity) {
        return undefined;
    }
    return findRateWithAmenity(rates, missingAmenity);
};
